import { render, staticRenderFns } from "./DefaultDataHeader.vue?vue&type=template&id=38f0faaf&scoped=true&"
import script from "./DefaultDataHeader.vue?vue&type=script&lang=js&"
export * from "./DefaultDataHeader.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDataHeader.vue?vue&type=style&index=0&id=38f0faaf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0faaf",
  null
  
)

export default component.exports